var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.$vuetify.breakpoint.mdAndUp)?_c('div',{staticClass:"header"},[_c('div',{staticClass:"headerTitle"},[_c('h2',[_vm._v(" "+_vm._s(_vm.title)+" ")])])]):_c('div',{staticClass:"mt-12"})
}
var staticRenderFns = []

export { render, staticRenderFns }